// extracted by mini-css-extract-plugin
export var active = "_83-2";
export var container = "_83-0";
export var expired = "_83-3";
export var hasStatus = "_83-4";
export var statusChip = "_83-1";